module.exports = __webpack_public_path__ + "img/yjzk.9af6cac0.svg";